export const leads = [
  { path: 'created', title: 'Creación', icon: 'mdi-calendar-blank-outline' },
  { path: 'forwarder.name', title: 'Derivador', icon: 'mdi-account-arrow-right' },
  { path: 'closingReason.description', title: 'Motivo de cierre', icon: 'mdi-close' },
  { path: 'activityScheduled', title: 'Vencimiento de la tarea', icon: 'mdi-calendar-blank-outline' },
]
